import React from 'react';
import { Form, Image, Button, Message } from 'semantic-ui-react';
import { writeValidationList } from '../../helper/form-helper';

class ProfileForm extends React.Component {

  constructor() {
    super();

    this.defaultState = {
      processing: false,
      formValues: {},
      formFieldValidity: {
        displayName: true,
        email: true,
        photoURL: true
      },
      formMessage: {
        msgHeader: '',
        negative: false,
        positive: false,
        //required for the message component as content
        list: []
      },
    }

    this.errMsgConfig = {
      displayName: {
        label: 'Display Name',
        err: 'Your Name is required and the field can\'t be empty'
      },
      email: {
        label: 'Email',
        err: 'Please enter a valid email address'
      },
      photoURL: {
        label: 'Photo URL',
        err: 'Please enter a valid URL to your photo'
      },
    }

    this.handleCancel = this.handleCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = Object.assign({}, this.defaultState)
  }

  componentWillMount() {
    if(this.props.message)
    this.setState({formMessage: this.props.message})
  }

  componentWillReceiveProps(newProps) {
    if(newProps.message)
    this.setState({formMessage: newProps.message})
    this.setState({processing: newProps.processing})
  }

  handleCancel() {
    this.setState(this.defaultState);
  }

  handleChange(e) {
    // extract fields values & load existing state
    const element = e.target;
    const value = element.type === 'checkbox' ? element.checked : element.value;
    const valid = element.validity.valid;

    // write state object with event's data
    const tmpFormValues = {
      ...this.state.formValues,
      [element.name]: value
    };

    // update validation state of fields
    const tmpFieldValidity = {
      ...this.state.formFieldValidity,
      [element.name]: valid
    };

    // hand errMsgConfig and updated formFieldValidity to helper to generate msgObj
    const tmpFormMessage = writeValidationList(this.errMsgConfig, tmpFieldValidity);

    this.setState({
      formValues: tmpFormValues,
      formMessage: tmpFormMessage,
      formFieldValidity: tmpFieldValidity
    })
  }

  render() {
    let { formFieldValidity } = this.state;
    let { msgHeader, positive, negative, list } = this.state.formMessage

    return (
      <Form
        onSubmit={(e) => this.props.handleSubmit(e, this.state.formValues)}>
        <div className="formInlineObj">
          <Form.Input
            width='13'
            label='Display Name'
            name='displayName'
            required
            error={!formFieldValidity.displayName}
            onChange={this.handleChange}
            defaultValue={this.props.displayName}/>
          <div className="separatorLeft" />
          <Image
            floated='right'
            size='tiny'
            shape='circular'
            src={this.props.photoURL} />
        </div>
          <div className="formInlineObj">
            <Form.Input
              width='13'
              label='URL to your Photo'
              name='photoURL'
              required
              type='URL'
              error={!formFieldValidity.photoURL}
              onChange={this.handleChange}
              defaultValue={this.props.photoURL}/>
            <Button
              disabled
              floated='right'
              className='formInlineBtn'
              icon='upload'
              />
          </div>
        {/* // TODO: I've taken out Email temporarily because it requires re-auth. */}
        {/* <Form.Input
          label='Email'
          name='email'
          required
          type='email'
          error={!formFieldValidity.email}
          onChange={this.handleChange}
          defaultValue={this.props.email} /> */}

        {/* Below the area that should require no customisation.
          It includes the message field and state handling */}

        { (this.state.formMessage.positive || this.state.formMessage.negative)
          ? <Message
            className='formMsg'
            positive={positive}
            negative={negative}
            header={msgHeader}
            list={list} /> : '' }
        <Button.Group fluid >
          <Button
            basic
            color='grey'
            type='reset'
            onClick={this.handleCancel}>
            Discard Changes
          </Button>
          <Button
            primary
            type='submit'
            disabled={this.state.processing || this.state.formMessage.negative}
            loading={this.state.processing}>
            Update Profile
          </Button>
        </Button.Group>
      </Form>
    );
  }

}

export default ProfileForm;



// WEBPACK FOOTER //
// ./src/components/forms/ProfileForm.js